import { GetUserCouncilRouteDocument, GetUserCouncilRouteQuery } from '@/council/graphql.generated';
import { getCurrentUser } from '@/hooks';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/council/')({
	beforeLoad: async ({ context }) => {
		const currentUser = await getCurrentUser(context.apolloClient);
		const { data } = await context.apolloClient.query<GetUserCouncilRouteQuery>({
			query: GetUserCouncilRouteDocument,
			variables: {
				id: currentUser?.id,
			},
		});
		if (
			currentUser?.roles.some((role) => role.name === 'COUNCIL') &&
			data?.user?.isCouncilStaffOf?.length &&
			data.user.isCouncilStaffOf.length > 0
		) {
			throw redirect({
				to: `/council/$councilId`,
				params: {
					councilId: data.user.isCouncilStaffOf[0].id,
				},
			});
		}
		throw redirect({ to: '/unauthorised' });
	},
});
